module.exports = __webpack_public_path__ + "img/herz.e6caa890.jpg";